import './Footer.css';

function Footer() {
  return (
    <main className="footer">
      <div className="footer-inner">
        <span className="footer-heart" aria-hidden="true">
          <svg viewBox="0 0 48 48" role="img" aria-hidden="true">
            <path
              d="M34 15c-1.9-1.9-5-1.9-6.9 0L24 18.1 20.9 15c-1.9-1.9-5-1.9-6.9 0-1.9 1.9-1.9 5 0 6.9L24 31.9l10-10c1.9-1.9 1.9-5 0-6.9Z"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <h2 className="footer-names">Pranav &amp; Sharu</h2>
        <p className="footer-note">with love!</p>
      </div>
    </main>
  );
}

export default Footer;
